import * as z from 'zod/mini'

/** A notification URL (`notifications/:notificationId/...`). */
export const notificationParams = z.object({ notificationId: z.uuid() })
export type NotificationParams = z.infer<typeof notificationParams>

/** No endpoint takes this yet; kept for the planned notification editor. */
export const editNotificationBody = z.object({
  title: z.optional(z.string()),
  description: z.optional(z.string()),
  icon: z.optional(z.string()),
  read: z.optional(z.boolean()),
})
export type EditNotificationBody = z.infer<typeof editNotificationBody>

export const setNotificationReadBody = z.object({ read: z.boolean() })
export type SetNotificationReadBody = z.infer<typeof setNotificationReadBody>
